export default __webpack_public_path__ + "static/media/BackupValidataionStatus02-MySQL.2da07558.png";